export const convertObjectPropertyToCssNotation = (propertyName: string) => {
  const baseKebab = propertyName.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);

  // The object notation for most vendor prefixes is pascal case (e.g.
  // `WebkitLineClamp`) which is handled by the above replacement. However, the
  // object notation for `-ms-*` is camel case (e.g. `msGridRow`) so it requires
  // additional handling.
  return baseKebab.startsWith('ms-') ? baseKebab.replace('ms-', '-ms-') : baseKebab;
};
